module.exports = __webpack_public_path__ + "media/images/xtendly-12cb7ebbaacf0b54e40a2adf0285a7b0.png";